import React from 'react';

import {
  OrderedListSectionWrapper,
  SectionBackgroundImage,
  StyledListItem, StyledOrderedList
} from 'organisms/mightyPro/OrderedListSection.styles';
import Heading from 'elements/typography/heading';
import Paragraph from 'elements/typography/paragraph';
import { OrderedListItem } from 'src/api/models/OrderedList';

interface OrderedListSectionProps {
  title: string;
  items: OrderedListItem[];
}

const OrderedListSection = (props: OrderedListSectionProps): JSX.Element => {
  const listItems = props.items.map(({ title, description }) => (
    <StyledListItem key={title}>
      <Paragraph text={title} size="16px" weight="normal" />
      <Paragraph text={description} size="16px" weight="light" />
    </StyledListItem>
  ));

  return (
    <OrderedListSectionWrapper>
      <SectionBackgroundImage />
      <Heading text={props.title}
        size="2rem"
        sizeSubLg="1.5rem"
        align="center" />
      <StyledOrderedList>
        {listItems}
      </StyledOrderedList>
    </OrderedListSectionWrapper>
  );
};

export default OrderedListSection;
